// extracted by mini-css-extract-plugin
export var freeGiftSelection = "styles-module--free-gift-selection--764b3";
export var freeGiftSelection__bottom = "styles-module--free-gift-selection__bottom--1e8d0";
export var freeGiftSelection__close = "styles-module--free-gift-selection__close--71618";
export var freeGiftSelection__products = "styles-module--free-gift-selection__products--e70f6";
export var freeGiftSelection__top = "styles-module--free-gift-selection__top--24222";